/** Where the reader was on a recipe page when they followed a link – for the way back. */
const leftPlaces = new Map<string, number>();

export function rememberLeftPlace(recipeId: string): void {
  leftPlaces.set(recipeId, window.scrollY);
}

/** The remembered scroll position of a recipe page; asking forgets it. */
export function takeLeftPlace(recipeId: string): number | undefined {
  const top = leftPlaces.get(recipeId);
  leftPlaces.delete(recipeId);
  return top;
}
